module.exports = __webpack_public_path__ + "static/media/PRACTICA11.31cf6c1b.png";